<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12">
    <slot />
    <path
      :fill="color"
      d="M10.5 0c.828 0 1.5.672 1.5 1.5v6c0 .828-.672 1.5-1.5 1.5H8v1.5c0 .78-.595 1.42-1.356 1.493L6.5 12h-5c-.78 0-1.42-.595-1.493-1.356L0 10.5v-6c0-.78.595-1.42 1.356-1.493L1.5 3H4V1.5C4 .72 4.595.08 5.356.007L5.5 0zM4 4H1.5c-.245 0-.45.177-.492.41L1 4.5v6c0 .245.177.45.41.492L1.5 11h5c.245 0 .45-.177.492-.41L7 10.5V9H5.5c-.78 0-1.42-.595-1.493-1.356L4 7.5V4zm1 3.5c0 .276.224.5.5.5h5c.276 0 .5-.224.5-.5v-6c0-.276-.224-.5-.5-.5h-5c-.276 0-.5.224-.5.5z"
    />
  </svg>
</template>

<script>
export default {
  props: {
    color: String,
  },
};
</script>
